<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Rule',
})
</script>
<template>
  <a-card title="订单">
    <template  #extra>
        <lanseed-form-only ref="form" :data="searchVal" :rules="searchRule" :mode="false" @change="search">
  </lanseed-form-only>
    </template>

    <a-table :dataSource="dataSource" :pagination="page"
    :loading="loading" :columns="columns" @change="pageChange" >
    <template #bodyCell="{ column, record,index }">
      <template v-if="column.key === 'pay'">
        <a-tag color="green" v-if="record.pay>0">已支付 {{ record.payno }}</a-tag>
        <a-tag color="gray" v-else>待支付</a-tag>
      </template>
      <template v-if="column.key === 'money'">
         <span class="price">{{ record.money }}</span>
      </template>
      <template v-if="column.key === 'status'">
         <span>{{ getStatus(record.status) }}</span>
      </template>
      <template v-if="column.key === 'operation'">
        <a-button-group>
            <a-button   size="small" type="primary" @click="openDetail(record.no)">
                <ContainerOutlined /> 详情
            </a-button>
          </a-button-group>
      </template>
    </template>
    </a-table>
    <detail ref="listdetail"></detail>
  </a-card>
</template>
<script setup lang="ts" name="Rule">
import api from '@/utils/http/service'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import detail from './detail.vue'
import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent} from 'vue'
import { PlusOutlined,EditOutlined,DeleteOutlined,ContainerOutlined} from '@ant-design/icons-vue'
import { useRoute } from 'vue-router'
import {DefaultRule} from '@/router/types'
  onMounted(()=>{
    getList()
    if(useRoute().meta.rule){
      pageRule.value=useRoute().meta.rule
    }
    api.list.status().then(res=>{
      if(res.data){
        types.value=res.data
      }
    })
  })
  const listdetail=ref()
  const types=ref([])
  const pageRule=ref<any>(DefaultRule())
const searchVal:Record=ref({
  keyword:'',stime:'',etime:'',pay:''
})
const searchRule:Record=ref({
  keyword:{name:'关键字'},
  stime:{domtype:'date',name:'开始日期'},
  etime:{domtype:'date',name:'截止日期'},
  pay:{domtype:'select',name:'是否支付',data:[{id:'',text:'不限'},{id:0,text:'待支付'},{id:1,text:'已支付'}]}
})
  const columns=[
    {
      title: '订单编号',
      dataIndex: 'no',key:'no'
    },
    {
      title: '金额',
      dataIndex: 'money',key:'money'
    },
    {
      title: '订单进度',
      dataIndex: 'status',key:'status'
    },
    {
      title: '是否支付',
      dataIndex: 'pay',key:'pay'
    },
    {
      title: '订购时间',
      dataIndex: 'retime',key:'retime'
    },
    {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 100,
  },
  ]
  const page=ref<PageData>({
    current:1,
    pageSize:10,
    pageFlag:true,
    total:0,
    pageStatus:'more',
    currentKey: 'pageIndex',
    pageSizeKey: 'pageSize',
  })
  const search=(e):void=>{
    searchVal.value=e
    page.value.current=1
    getList()
  }
  const getStatus=(e):void=>{
    var i= types.value.findIndex(f=>{return f.id==e})
    if(i>-1){
      return types.value[i].text
    }else{
      return '-'
    }
  }
  const loading=ref<boolean>(false)
  const dataSource=ref<Array<any>>([])
  const getList=():void=>{
    loading.value=true
      api.list.list({pageIndex:page.value.current,pageSize:page.value.pageSize,...searchVal}).then(res => {
        loading.value=false
        dataSource.value=res.data.data
        page.value.total=res.data.records
        page.value.current=res.data.pageIndex

      })
  }
  const pageChange=(e:anly)=>{
    page.value=e
    getList()
  }
  const openDetail=(no:String):void=>{
    listdetail.value.getData(no)
  }
</script>
